
































































    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import PageRequest from '@/store/entities/page-request'
    import Enums from '@/lib/enums'
    import DateUtils from '@/common/js/DateUtils'
    import storeaddressInfo from '@/store/entities/back-storeaddress-list'


    class PageFlowRequest extends PageRequest {
        beginTime?: Date;
        endTime?: Date;
        statisticalType: number;
        //channel: number;
        orderType: number;
        storeId?: number;
        site?: number;
        constructor() {
            super();
            this.statisticalType = 1;
            //this.channel = 2;
            this.orderType = 0;
            this.site = null;
        }
    }

    @Component({
        name: "amountFlowStatistical",
    })
    export default class flows extends AbpBase {
        channel = Enums.UserAmountChannel;
        orderType = Enums.WarehouseOrderType;
        statisticalType = Enums.StatisticalType;
        siteType = Enums.getEnum(Enums.ShopSiteType, true);
        pagerequest: PageFlowRequest = new PageFlowRequest();
        packedTime: Date[] = [new Date(), new Date()];
        storeaddressList: Array<storeaddressInfo> = [];
        isDisplay: boolean = false;
        get list() {
            return this.$store.state.flowAmountStatistical.list;
        };
        get loading() {
            return this.$store.state.flowAmountStatistical.loading;
        };
        //pageChange(page: number) {
        //    this.$store.commit('packstatistical/setCurrentPage', page);
        //    this.getpage();
        //};
        //pagesizeChange(pagesize: number) {
        //    this.$store.commit('packstatistical/setPageSize', pagesize);
        //    this.getpage();
        //};

        async getpage() {
            this.pagerequest.maxResultCount = this.pageSize;
            this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
            //filters

            if (this.packedTime.length > 0) {
                this.pagerequest.beginTime = this.packedTime[0];
            }
            if (this.packedTime.length > 1) {
                this.pagerequest.endTime = this.packedTime[1];
            }

            await this.$store.dispatch({
                type: 'flowAmountStatistical/getAll',
                data: this.pagerequest
            })
        }
        async searchPage() {
            this.$store.state.flowAmountStatistical.currentPage = 1;
            this.getpage();
        }
        get pageSize() {
            return this.$store.state.flowAmountStatistical.pageSize;
        }
        get totalCount() {
            return this.$store.state.flowAmountStatistical.totalCount;
        }
        get currentPage() {
            return this.$store.state.flowAmountStatistical.currentPage;
        }
        async getData() {
            await this.$store.dispatch({
                type: 'backstoreaddress/getAll',
                data: {}
            })
            var a = new storeaddressInfo();
            a.id = null;
            a.storeName = "全部";
            this.storeaddressList = this.$store.state.backstoreaddress.list.filter(function (item) { return item.whetherEffective == true });
            this.storeaddressList.push(a);

        }
        changestatus(a: any) {
            this.pagerequest.storeId = null;
            if (a == 2||a==3) {
                this.getData();
                this.isDisplay = true;
            }
            else {
                this.isDisplay = false;
            }
        }
        columns = [
            {
            title: '支付宝充值',
            sortable: true,
            key: 'alipay',
            width: 211,
         
            },
            {
                title: '平台消费',
                sortable: true,
                key: 'platformConsumption',
                width: 211,
         
            },
            {
                title: '平台退款',
                sortable: true,
                key: 'platformRefund',
                width: 211,
             
            },
            {
                title: '退货消费',
                sortable: true,
                key: 'returnCost',
                width: 211,
          
            },
            {
                title: '打包消费',
                sortable: true,
                key: 'packedCost',
                width: 211,

            },
            {
                title: '打包退款',
                sortable: true,
                key: 'packedRefund',
                width: 211,

            },
            {
                title: '运费消费',
                sortable: true,
                key: 'freightCost',
                width: 211,
            },
            {
                title: '运费退款',
                sortable: true,
                key: 'freightRefund',
                width: 211,
            },
            {
            title: '日期',
            sortable: true,
            key: 'createTime',
            width: 300,
            render: (h: any, params: any) => {
                return h('span', params.row.createTime == null ? "" : DateUtils.formatLongDate(new Date(params.row.createTime)));
            }
            }
        ]
        async created() {
            this.getpage();
        }
    }
